// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3gbVy","inner":"Footer_inner__1txWm"};